import React from "react";
import QRCode from "react-qr-code";
import {Business, CurrentUser, UserCard} from "../../types/Types";
import "../../App.css"
import "./PointsCardV2.css";
import {QR_CODE_URL} from "../../utils/Constants";
import NumberFlow from "@number-flow/react";
import continuous from "number-flow";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import {convertTimestamp} from "../../utils/Utils";

interface Props {
  user: CurrentUser,
  pointsCard: UserCard,
  business: Business | undefined,
}

function PointsCardV2(props: Props) {
  if(!props.business) {
    return <></>
  }

  const cardConfig = props.business.configuration.card;

  return (
      <div className={"points-card"} style={{backgroundColor: cardConfig.bgColour, color: cardConfig.fgColour}}>
        <div className={"card-container"}>
          <div className={"card-left"}>
            {props.business && <div className={"card-business-logo"}
                                    style={{
                                      fontWeight: cardConfig.fontWeight,
                                      fontFamily: cardConfig.font
                                    }}>{cardConfig.toUpperCase ? props.business.name.toUpperCase() : props.business.name}</div>}
            <div className={"card-user-name"}>{props.user.name.toUpperCase()}</div>
            <div className={"card-expiry font-mono"}>
              <span>EXP:</span><span className={"ms-1 me-3"}>{convertTimestamp(props.pointsCard.expiresAt)}</span>
              <span>ID:</span><span className={"ms-1"}>{props.pointsCard.cardNumber}</span>
            </div>
          </div>
          <div className={"card-right"}>
            <div className={"card-points-wrapper"}>
              <NumberFlow plugins={[continuous]} value={props.pointsCard.points} />
              <FontAwesomeIcon className={"ms-1"} icon={faStar} />
            </div>
            <div className={"card-qr-code"}>
              <QRCode
                  size={256}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={QR_CODE_URL + "/card/" + props.pointsCard.id}
                  viewBox={`0 0 256 256`}
                  bgColor={props.business.configuration.card.bgColour}
                  fgColor={props.business.configuration.card.fgColour}
              />
            </div>
          </div>
        </div>
      </div>
    )
}

export default PointsCardV2;